export default function MangalDoshaSeoContent() {
  return (
    <div className="mt-12 card-sacred p-6 sm:p-8">
      <h2
        className="text-[20px] font-bold mb-4"
        style={{
          fontFamily: "var(--font-pt-serif), PT Serif, Georgia, serif",
          color: "var(--ish-dark)",
        }}
      >
        What is Mangal Dosha?
      </h2>
      <div
        className="space-y-3 text-[14px] leading-relaxed"
        style={{ color: "var(--ish-text-muted)" }}
      >
        <p>
          <strong style={{ color: "var(--ish-dark)" }}>Mangal Dosha</strong> (also called Kuja Dosha
          or Manglik Dosha) is an astrological condition that occurs when Mars (Mangal) is placed in
          the 1st, 2nd, 4th, 7th, 8th, or 12th house of a person&apos;s birth chart. According to
          Vedic astrology, this placement can influence married life and relationships.
        </p>
        <p>
          Mars is a fiery, aggressive planet. When placed in certain houses related to marriage and
          partnerships, it is traditionally believed to bring challenges such as conflicts, delays
          in marriage, or compatibility issues. The severity depends on the exact house, any aspects
          from benefic planets, and cancellation conditions (Mangal Dosha Bhanga).
        </p>
        <p>
          <strong style={{ color: "var(--ish-dark)" }}>Important:</strong> Many charts have partial
          cancellations. For example, if Mars is in its own sign (Aries or Scorpio), in the sign of
          a friend, or aspected by Jupiter, the dosha effect is significantly reduced. A
          comprehensive kundali reading considers all these factors.
        </p>
        <p>
          Traditional remedies include performing Kumbh Vivah, chanting Mangal mantras, fasting on
          Tuesdays, wearing a coral gemstone (after proper consultation), and visiting Mangalnath
          Temple in Ujjain.
        </p>
      </div>
    </div>
  );
}
